module.exports = __webpack_public_path__ + "static/x48-3acb0b96c6429151706cf944b49ea6c7.png";